import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useStaticData } from '@mc/static-data-react'
import { PageSource } from '@mc/track-event'
import BusinessBanner from 'components/BusinessBanner'
import { ClassSampleEmailCapture } from 'components/EmailCapture'
import { useCourseBySlug, useRelatedArticlesByCategory } from 'libs/client/api'
import setupHighlightShare from '../../libs/highlightShare'
import FeaturedInstructor from '../FeaturedInstructor'
import RelatedArticles from '../RelatedArticles'
import SharedRecipeEmailCapture from '../SharedRecipeEmailCapture'

const BelowTheFold = () => {
  const { article } = useStaticData()
  const { courseBySlug, error: courseBySlugError } = useCourseBySlug(
    article.featuredCourseSlug,
  )
  const { relatedArticlesByCategory, error: relatedArticlesError } =
    useRelatedArticlesByCategory(article.category.id)
  const router = useRouter()
  const { shared } = router.query

  useEffect(() => {
    setupHighlightShare()
  }, [])

  return (
    <>
      <ClassSampleEmailCapture
        className='mc-bg-gray-700 mc-p-6'
        trackProps={{
          location: 'article_page_body_slim_banner',
          contentType: 'articles',
          slug: article.featuredCourseSlug,
        }}
        preSelectedCategorySlug={article?.category?.slug}
        isLightMode={true}
      />
      {courseBySlug && !courseBySlugError && <FeaturedInstructor />}
      <BusinessBanner pageSource={PageSource.ARTICLE} isInline isLightTheme />
      {relatedArticlesByCategory && !relatedArticlesError && (
        <RelatedArticles />
      )}
      {shared && <SharedRecipeEmailCapture />}
    </>
  )
}

export default BelowTheFold
